module.exports = __webpack_public_path__ + "static/img/kids-img-03@t.242e278.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/kids-img-03@t.jpg
// module id = LJ8p
// module chunks = 0